import autosize from 'autosize/dist/autosize';

export default function initTextareaAutosize() {
    $('textarea.auto-expand').each(function () {
        checkIfVisible($(this), true);
    });
}

function checkIfVisible(elm, addListener = false) {
    if (elm.is(':visible')) {
        autosize(elm);
        if (elm._visibilityCheckInterval) {
            clearInterval(elm._visibilityCheckInterval);
        }
        return;
    }
    if (addListener) {
        elm._visibilityCheckInterval = setInterval(function () {
            checkIfVisible(elm)
        }, 500);
    }
}
